import digitalData from 'digital-data';
import {
  OVERLAY,
  BUTTON_SUBMISSION,
  MY_ACCOUNT_SETTINGS,
  QUICK_ESTIMATE,
  QUICK_ESTIMATE_CLOSE,
  QUICK_ESTIMATE_PAGE_SECTION,
  QUICK_ESTIMATE_LOADING_INTERRUPTED,
} from '../constants';

// Req 1: Overlay seen — fires when Quick Estimate button is clicked
const quickEstimateOpen = () => {
  LIFE_CYCLE_EVENT_BUS.on('quick-estimate.open', () => {
    digitalData.event.push({
      category: { primaryCategory: OVERLAY },
      eventInfo: { eventName: QUICK_ESTIMATE },
    });
  });
};

// Req 2: Drawer closed — fires on every close action (footer Close or X button)
const quickEstimateClose = () => {
  LIFE_CYCLE_EVENT_BUS.on('quick-estimate.close', () => {
    digitalData.event.push({
      category: { primaryCategory: BUTTON_SUBMISSION },
      eventInfo: { eventName: MY_ACCOUNT_SETTINGS },
      myAccount: { settings: QUICK_ESTIMATE_CLOSE },
    });
  });
};

// Req 3: Loading interrupted — fires only when closed while isResolving === true
// Uses actual error message from resolution process if provided; defaults to the constant
const quickEstimateLoadingInterrupted = () => {
  LIFE_CYCLE_EVENT_BUS.on('quick-estimate.loading-interrupted', ({ output }) => {
    const { message = QUICK_ESTIMATE_LOADING_INTERRUPTED } = output || {};
    digitalData.event.push({
      category: { primaryCategory: 'error' },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type: 'error',
          displayType: 'inline',
          pageSection: QUICK_ESTIMATE_PAGE_SECTION,
          message,
          code: 'n/a',
        }],
      },
    });
  });
};

export const proPlanningTools = () => {
  quickEstimateOpen();
  quickEstimateClose();
  quickEstimateLoadingInterrupted();
};
